<style>
.btn-apply-condition {
  position: relative !important;
  width: 100%;
  box-shadow: 0 0 0 transparent;
  color: #fff;
  border: 1px solid #624dd6;
  font-size: 12px;
  padding: 7px 10px;
  background: #624dd6;
  display: block;
  border-radius: 4px;
  margin-top: 7px;
}
</style>

<template>
  <div class="accordion" id="accordionAutomation">

    <div class="card">
      <div class="card-header automation-card-header" id="headingOne">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            {{ lang.users }}
          </button>
        </p>
      </div>
      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionAutomation">
        <div class="card-body">
          <div id="filterSearch" class="workflow-row-details">
            <ul>
              <li v-for="field in fields.user_name" v-if="field.name"><a href="javascript:void(0)"
                                                                         v-on:click.stop.prevent="mailToFrom(field, 'new')">{{
                  field.email
                }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header automation-card-header" id="headingTwo">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            {{ this.SelectedTableLabel }} {{ lang.record }}
          </button>
        </p>
      </div>
      <div id="collapseTwo" class="collapse" aria-labelledby="headingOne" data-parent="#accordionAutomation">
        <div class="card-body">
          <div id="filterSearch" class="workflow-row-details">
            <ul>
              <li v-if="SelectedTableExcludedColumnList == undefined || SelectedTableExcludedColumnList.length == 0"
                  style="font-size: 12px;margin-left: 20px;">No Data
              </li>
              <li v-for="field in SelectedTableExcludedColumnList" v-if="field.name"><a href="javascript:void(0)"
                                                                                        v-on:click.stop.prevent="mailToFrom(field, 'new')">{{
                  field.label
                }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="executeHandler != 1 && executeHandler != 2">
      <div class="card-header automation-card-header" id="headingThree">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
            {{ this.SelectedTableLabel }} {{ lang.record }}.{{ lang.old }} {{ lang.values }}
          </button>
        </p>
      </div>
      <div id="collapseThree" class="collapse" aria-labelledby="headingOne" data-parent="#accordionAutomation">
        <div class="card-body">
          <div id="filterSearch" class="workflow-row-details">
            <ul>
              <li v-if="SelectedTableExcludedColumnList == undefined || SelectedTableExcludedColumnList.length == 0"
                  style="font-size: 12px;margin-left: 20px;">No Data
              </li>
              <li v-for="field in SelectedTableExcludedColumnList" v-if="field.name"><a href="javascript:void(0)"
                                                                                        v-on:click.stop.prevent="mailToFrom(field, 'old')">{{
                  field.label
                }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="custom">
      <div class="card-header automation-card-header" id="headingCustom">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  data-target="#collapseCustom" aria-expanded="false" aria-controls="collapseCustom">
            {{ lang.custom }}
          </button>
        </p>
      </div>
      <div id="collapseCustom" class="collapse" aria-labelledby="headingCustom" data-parent="#accordionAutomation">
        <div class="card-body">
          <div id="filterSearch" class="workflow-row-details">
            <input type="text"
                   v-model="getInputEmail"
                   class="form-control custom-input-value"
                   :placeholder="lang.enter+' '+lang.value.toLowerCase()"
                   name="custom_text"
            />
            <button
                class="btn btn-outline-primary btn-apply-condition"
                autofocus="on"
                v-if="custom"
                v-on:click.stop.prevent="inputMailAddress()">
              {{ lang.apply }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: [
    'fields', //selected table fields
    'table', // selected table name
    'level', // advanced condition level
    'fieldId',
    'custom',
    'MapValuesEmail',
    'executeHandler',
    'SelectedTableLabel',
    'SelectedTableExcludedColumnList',
    'lang',
  ],
  data() {
    return {
      getInputEmail: null,
      hasCustom: false,
    }
  },
  mounted() {
    if (this.MapValuesEmail && this.MapValuesEmail[this.fieldId] != null) {
      if (this.MapValuesEmail[this.fieldId].hasCustom) {
        this.getInputEmail = this.MapValuesEmail[this.fieldId].selected_field.name;
      }
    }
  },
  created() {
    // console.log(this.lang);
  },
  methods: {

    mailToFrom(field, record_type) {
      let data = {
        selected_field: field,
        record_type: record_type,
        hasCustom: this.hasCustom
      };

      this.$emit('SelectedMailToFromDetailsEvent', 'email', this.fieldId, data);
    },
    inputMailAddress(event) {
      this.hasCustom = true;

      let data = {
        selected_field: {
          'email': this.getInputEmail,
          'name': this.getInputEmail,
          'id': null,
        },
        record_type: 'new',
        hasCustom: this.hasCustom
      };

      if (this.getInputEmail) {
        if (!this.validEmail(this.getInputEmail)) {
          alert('Valid email required.');
        } else {
          this.$emit('SelectedMailToFromDetailsEvent', 'email', this.fieldId, data);
        }
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email);
    }
  }
}
</script>
